import AllProjects from "./allProjects";

export default AllProjects;
